import { render, staticRenderFns } from "./ReglementBill.vue?vue&type=template&id=2fc8d3f8&"
import script from "./ReglementBill.vue?vue&type=script&lang=js&"
export * from "./ReglementBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports